import * as Sentry from '@sentry/vue';
import { reactive } from 'vue';
import pushService from '@/general/services/PushService';
import DmsSyncStatus from '@/shared/models/DmsSyncStatus';
import { NotFound } from '@/shared/utils/errors';
import JobEvenMessage from '../constants/JobEvenMessage';
import LoadingService from './LoadingService';

class DmsService {
  private active = false;

  async processSyncWithStatus(status: DmsSyncStatus): Promise<void> {
    if (!status.finishedImporting) {
      await this.processSync(
        `${status.pusherChannel}/${status.pusherChannelEventName}`,
      );
    }
  }

  async processSync(eventName: string): Promise<void> {
    try {
      this.active = true;
      LoadingService.start();

      await pushService.sequence(eventName, (event, resolve, reject) => {
        switch (event.eventMessage) {
          case JobEvenMessage.IMPORTED:
            LoadingService.pushMessage('dms.imported');
            break;
          case JobEvenMessage.PROCESSED:
            LoadingService.pushMessage('dms.processed');
            resolve();
            break;
          case JobEvenMessage.NO_DATA:
            reject(new NotFound());
            break;
        }
      });
    } catch (err) {
      Sentry.captureException(err, {
        level: 'error',
        tags: { section: 'dms', method: 'processSync' },
        extra: { eventName },
      });
      throw err;
    } finally {
      this.active = false;
      await LoadingService.stop();
    }
  }
}

export default reactive(new DmsService());
